import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6dd3c8fa"
import script from "./addDunningMaster.js?vue&type=script&lang=js&external"
export * from "./addDunningMaster.js?vue&type=script&lang=js&external"
import style0 from "./addDunningMaster.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports